import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {AbstractRESTService} from "./abstract.rest.service";
import {Router} from "@angular/router";

@Injectable()
export class AuthRESTService extends AbstractRESTService {

    constructor(http: Http, router: Router) {
        super(http, environment.restUrl, router)
    }

    protected createCustomHeaders(): RequestOptions {
        return new RequestOptions({
            //headers: new Headers({'Authorization': 'Basic ' + new Buffer('admin' + ':' + 'admin123').toString('base64')}),
            headers: new Headers({'Authorization': 'Bearer ' +localStorage.getItem("tokenJWT")}),
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/services/rest/auth-rest.service.ts